import React from 'react';
import { Typography } from '@material-ui/core';

const EstadisticasHeader = ({ stats }) => {
  return (
    <Typography variant="body2" color="textSecondary">
      {stats.totalPracticas || 0} practicas &bull; {stats.practicasRectificadas || 0} rectificadas &bull; {stats.alumnosRectificados || 0} alumnos rectificados
    </Typography>
  );
};

export default EstadisticasHeader;
